import { Component } from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {LoadingService} from "../../services/loading.service";

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  constructor(private spinner: NgxSpinnerService,
              private loadingService: LoadingService) {
    this.loadingService.isLoading.subscribe(isLoading => {
      if (isLoading) {
        this.spinner.show();
      } else {
        this.spinner.hide();
      }
    });
  }
}
